import { C } from "../utils/tokens";

const GlobalStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Instrument+Serif:ital@0;1&family=DM+Mono:wght@400;500&family=Figtree:wght@400;500;600;700&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
    body{background:${C.bg};color:${C.text};font-family:'Figtree',sans-serif;-webkit-font-smoothing:antialiased;}
    input,textarea,select{font-family:inherit;}
    input::placeholder,textarea::placeholder{color:rgba(255,255,255,0.18);}
    ::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-track{background:transparent;}
    ::-webkit-scrollbar-thumb{background:rgba(245,197,24,0.2);border-radius:2px;}
    button{cursor:pointer;font-family:inherit;}
    @keyframes fadeUp{from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);}}
    @keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
    @keyframes glow{0%,100%{box-shadow:0 0 20px rgba(245,197,24,0.2);}50%{box-shadow:0 0 50px rgba(245,197,24,0.45);}}
    @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.5;}}
    .au{animation:fadeUp 0.45s ease both;}
    .au1{animation:fadeUp 0.45s 0.05s ease both;}
    .au2{animation:fadeUp 0.45s 0.12s ease both;}
    .au3{animation:fadeUp 0.45s 0.20s ease both;}
    .au4{animation:fadeUp 0.45s 0.28s ease both;}
    .au5{animation:fadeUp 0.45s 0.36s ease both;}
  `}</style>
);

export default GlobalStyle;
